/* Blog CRO template, K-Beauty Store. Werkt samen met Blockshop (cart-element). */
(function () {
  if (window.BlogCRO) return;
  window.BlogCRO = true;

  var money = function (cents, currency) {
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  };

  var track = function (name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('blog_interaction', Object.assign({ action: name }, payload || {})); } catch (e) {}
  };

  /* Toevoegen aan winkelwagen via de Blockshop Cart-klasse (opent de drawer zelf). */
  var Cart = window.customElements ? customElements.get('cart-element') : null;
  var addItems = function (items, buttonEl, source) {
    var body = { items: items.map(function (i) { return { id: i.id, quantity: i.quantity || 1, properties: { _source: source || 'blog' } }; }) };
    if (Cart && Cart.addItems) {
      body.sections = Cart.sections;
      return Cart.addItems({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }, buttonEl || true);
    }
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(r.statusText); window.location.href = (Shopify.routes && Shopify.routes.root || '/') + 'cart'; });
  };

  var init = function () {
    /* Leesvoortgang */
    var bar = document.querySelector('.js-bc-progress');
    if (bar) {
      var onScroll = function () {
        var d = document.documentElement, max = d.scrollHeight - window.innerHeight;
        bar.style.width = (max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }

    /* Inhoudsopgave uit H2's */
    var prose = document.querySelector('.js-bc-prose');
    if (prose) {
      var heads = Array.prototype.slice.call(prose.querySelectorAll('h2')).filter(function (h) { return h.textContent.trim().length > 0; });
      var used = {};
      var links = heads.map(function (h) {
        var id = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
        while (used[id]) id += '-2';
        used[id] = true; h.id = id;
        return { href: '#' + id, label: h.textContent.trim(), el: h };
      });
      if (prose.dataset.hasRoutine === 'true') links.push({ href: '#routine', label: prose.dataset.tRoutine || 'Shop de routine' });
      if (prose.dataset.hasProducts === 'true') links.push({ href: '#producten', label: prose.dataset.tProducts || 'Alle producten' });

      var lists = document.querySelectorAll('.js-bc-toc-list');
      Array.prototype.forEach.call(lists, function (list) {
        links.forEach(function (l) {
          var a = document.createElement('a'); a.href = l.href; a.textContent = l.label; a.className = 'bc-toc__link';
          a.addEventListener('click', function () { track('toc_click', { target: l.href }); var mob = a.closest('.js-bc-toc-mobile'); if (mob) toggleMobile(false); });
          list.appendChild(a);
        });
      });
      var mobileWrap = document.querySelector('.js-bc-toc-mobile');
      var toggleBtn = document.querySelector('.js-bc-toc-toggle');
      var toggleMobile = function (open) {
        if (!mobileWrap) return;
        var list = mobileWrap.querySelector('.js-bc-toc-list');
        list.hidden = !open; toggleBtn.setAttribute('aria-expanded', String(open));
        toggleBtn.querySelector('.bc-toc-mobile__icon').textContent = open ? '−' : '+';
      };
      if (mobileWrap && links.length) { mobileWrap.hidden = false; toggleBtn.addEventListener('click', function () { toggleMobile(toggleBtn.getAttribute('aria-expanded') !== 'true'); }); }

      /* Actieve kop markeren: laatste kop boven 30% van het scherm */
      var desktopLinks = document.querySelectorAll('.js-bc-toc-desktop .bc-toc__link');
      if (heads.length && desktopLinks.length) {
        var ticking = false;
        var markActive = function () {
          ticking = false;
          var line = window.innerHeight * 0.3, current = heads[0].id;
          for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top <= line) current = heads[i].id; }
          var extra = document.querySelector('#routine');
          if (extra && extra.getBoundingClientRect().top <= line) current = 'routine';
          var extra2 = document.querySelector('#producten');
          if (extra2 && extra2.getBoundingClientRect().top <= line) current = 'producten';
          Array.prototype.forEach.call(desktopLinks, function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current); });
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(markActive, 60); } }, { passive: true });
        markActive();
      }
    }

    /* Losse Toevoegen-knoppen */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.js-bc-add');
      if (!btn) return;
      ev.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      addItems([{ id: btn.dataset.variantId }], btn, btn.dataset.source).then(function () {
        btn.textContent = btn.dataset.addedLabel || 'Toegevoegd ✓'; btn.classList.add('is-added');
        track('add_to_cart', { source: btn.dataset.source, variant: btn.dataset.variantId });
      }).catch(function () { btn.textContent = btn.dataset.retryLabel || 'Probeer opnieuw'; }).finally(function () { btn.removeAttribute('aria-busy'); });
    });

    /* Shop de routine */
    var track_ = document.querySelector('.js-bc-routine-track');
    if (track_) {
      var cards = Array.prototype.slice.call(track_.querySelectorAll('.js-bc-rcard'));
      var countEl = document.querySelector('.js-bc-routine-count'), totalEl = document.querySelector('.js-bc-routine-total');
      var addAll = document.querySelector('.js-bc-routine-add');
      var currency = totalEl && totalEl.dataset.currency;
      var recalc = function () {
        var on = cards.filter(function (c) { return c.classList.contains('is-on'); });
        var total = on.reduce(function (s, c) { return s + parseInt(c.dataset.price, 10); }, 0);
        if (countEl) countEl.textContent = on.length; if (totalEl) totalEl.textContent = money(total, currency);
        if (addAll) addAll.disabled = on.length === 0;
      };
      cards.forEach(function (c) {
        var t = c.querySelector('.js-bc-rcard-toggle');
        t.addEventListener('click', function () {
          c.classList.toggle('is-on'); t.setAttribute('aria-pressed', String(c.classList.contains('is-on')));
          track('routine_toggle', { variant: c.dataset.variantId, on: c.classList.contains('is-on') }); recalc();
        });
      });
      recalc();
      if (addAll) addAll.addEventListener('click', function () {
        var items = cards.filter(function (c) { return c.classList.contains('is-on'); }).map(function (c) { return { id: c.dataset.variantId }; });
        if (!items.length) return;
        addAll.setAttribute('aria-busy', 'true');
        addItems(items, addAll, addAll.dataset.source).then(function () { track('routine_add_all', { count: items.length }); })
          .catch(function () { addAll.textContent = addAll.dataset.retryLabel || 'Probeer opnieuw'; }).finally(function () { addAll.removeAttribute('aria-busy'); });
      });

      /* Mobiele carrousel */
      var nav = document.querySelector('.js-bc-routine-nav');
      var dotsWrap = document.querySelector('.js-bc-routine-dots');
      var mq = window.matchMedia('(max-width: 759px)');
      var setupNav = function () {
        if (!nav) return;
        nav.hidden = !mq.matches;
        if (!mq.matches) return;
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'bc-dot'; d.setAttribute('aria-label', ((document.querySelector('.js-bc-prose')||{dataset:{}}).dataset.tStep || 'Ga naar stap') + ' ' + (i + 1)); d.addEventListener('click', function () { c.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }); dotsWrap.appendChild(d); });
        var update = function () {
          var w = cards[0].getBoundingClientRect().width + 10; var idx = Math.round(track_.scrollLeft / w);
          Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        };
        track_.addEventListener('scroll', update, { passive: true }); update();
        document.querySelector('.js-bc-routine-prev').onclick = function () { track_.scrollBy({ left: -(cards[0].getBoundingClientRect().width + 10), behavior: 'smooth' }); };
        document.querySelector('.js-bc-routine-next').onclick = function () { track_.scrollBy({ left: cards[0].getBoundingClientRect().width + 10, behavior: 'smooth' }); };
      };
      setupNav(); mq.addEventListener ? mq.addEventListener('change', setupNav) : mq.addListener(setupNav);
    }

    /* Productgrid: toon alle */
    var grid = document.querySelector('.js-bc-grid'), gridBtn = document.querySelector('.js-bc-grid-toggle');
    if (grid && gridBtn) gridBtn.addEventListener('click', function () {
      var open = grid.classList.toggle('is-open');
      gridBtn.textContent = open ? gridBtn.dataset.less : gridBtn.dataset.more; gridBtn.classList.toggle('bc-btn--ghost', open);
      track('grid_toggle', { open: open });
      if (!open) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Reviews: kaarten zonder Judge.me-reviews verbergen; sectie weg als er niets overblijft */
    var reviews = document.querySelector('.js-bc-reviews');
    if (reviews) {
      var checkReviews = function () {
        var cards = reviews.querySelectorAll('.js-bc-review-card'), left = 0;
        Array.prototype.forEach.call(cards, function (c) {
          var w = c.querySelector('.jdgm-rev-widg');
          if (!w) { left++; return; }
          var n = parseInt(w.getAttribute('data-number-of-reviews') || '0', 10);
          if (n > 0) left++; else c.hidden = true;
        });
        if (reviews.querySelector('.jdgm-rev-widg') && !left) reviews.hidden = true;
      };
      var tries = 0, timer = setInterval(function () { checkReviews(); if (++tries > 20 || reviews.querySelector('.jdgm-rev-widg')) clearInterval(timer); }, 500);
      document.addEventListener('jdgm.reviewsLoaded', checkReviews);
    }

    /* FAQ tracking */
    Array.prototype.forEach.call(document.querySelectorAll('.bc-faq__item'), function (d) { d.addEventListener('toggle', function () { if (d.open) track('faq_open', { q: d.querySelector('summary').textContent.trim() }); }); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
